import { Component } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AccountGroup, AccountSubGroupType, AccountTypes, gridPageRequest, Product } from '../../../model/common/common.model';
import { AccountService } from '../../../services/account.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CloseQuickCustomerLookupComponent } from '../../Lookup/close-quick-customer-lookup/close-quick-customer-lookup.component';
import { AccountGroupLookupComponent } from '../../Lookup/create-quick-account-group-lookup/create-quick-account-group-lookup.component';
import { AccountTypeLookupComponent } from '../../Lookup/create-quick-account-type-lookup/create-quick-account-type-lookup.component';
import { AccountSubGrouptypeLookupComponent } from '../../Lookup/create-quick-account-type-lookup copy/create-quick-account-SubGrouptype-lookup.component';


@Component({
  selector: 'app-create-accounts',
  standalone: true,
  imports: [SharedModule, CommonModule, AutoCompleteModule],
  providers: [MessageService],
  templateUrl: './create-accounts.component.html',
  styleUrl: './create-accounts.component.scss'
})
export class CreateAccountsComponent {
  selectedAccountTypeId: Number | null = null;



  constructor(public dialogService: DialogService, public ref: DynamicDialogRef, private messageService: MessageService, private router: Router, private routers: ActivatedRoute, private accountService: AccountService) {
  }
  loader: any;
  submitted: boolean = false;
  isEditMode: boolean = false;
  isManual: boolean = false;
  accountsId: number | undefined;
  activeIndex = 0;
  ledgerFromDate: Date | null = null;
  ledgerToDate: Date | null = null;
  ledgerOpeningBalance = 0;
  ledgerClosingBalance = 0;
  ledgerLines: any[] = [];
  ledgerLoading = false;
  balanceRefreshing = false;
  displayCurrentBalance = '₹0.00';
  AccountGroup: AccountGroup[] = [];
  UOMDropdown: AccountTypes[] = [];
  AccountSubGroupDropdown: AccountSubGroupType[] = [];

  filteruom: AccountTypes[] = [];
  filterAccountSubGroup: AccountSubGroupType[] = [];
  products: Product[] = [];
  //  AccountgroupList: AccountGroup[]=[];
  AGDropdown: AccountGroup[] = [];
  filterAG: AccountGroup[] = [];
  accountTypeId: any;
  accountGroupId: any;
  accountSubGroupId: any;
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 1000,
    id: 0
  }



  createAccountForm = new FormGroup({
    accountGroups: new FormControl(),
    accountType: new FormControl('', Validators.required),
    accountSubGroup: new FormControl(),
    accountCode: new FormControl('', Validators.required),
    accountName: new FormControl('', Validators.required),
    accountDescription: new FormControl(),
    accountTypeId: new FormControl('', Validators.required),
    accountTypeCode: new FormControl(),
    ClosingBalance: new FormControl(0),
    accountSubGroupId: new FormControl(),
    accountSubGroupCode: new FormControl(),
    accountsubGroupDescription: new FormControl(),
    accountSubGroupName: new FormControl(),
    accountTypeName: new FormControl(),
    accountGroupId: new FormControl('', Validators.required),
    accountGroupCode: new FormControl('', Validators.required),
    tags: new FormControl(),
    financialStatement: new FormControl(''),
    accountSubType: new FormControl(),
    accountGroupDescription: new FormControl(),
    manualEntry: new FormControl(true),
    // CheckBox
    isDepreciated: new FormControl(false),
    isActive: new FormControl(true, Validators.requiredTrue),
    isSalesTaxAcc: new FormControl(),
    createdBy: new FormControl(''),
    updatedBy: new FormControl(''),
    accountGroupName: new FormControl('', Validators.required),
  });

  ngOnInit(): void {
    document.title = 'Create Account';
    this.getit();
    this.getUOM();
    this.getAG();
    this.getAccountSubGroupType();
    this.setAccountGroup;
    this.createAccountForm.controls.createdBy.setValue(localStorage.getItem('username'));
    this.createAccountForm.patchValue({ ClosingBalance: 0 });
  }

  createQuickAccountGroup(status: boolean = true) {
    const dialogRef = this.dialogService.open(AccountGroupLookupComponent, {
      header: 'Create Quick Account Group',
      width: '70%',
      height: '65%'
    });

    dialogRef.onClose.subscribe((accountGroupId: number) => {
      if (accountGroupId) {
        this.getAccountGroupData(accountGroupId);
      }
    });
  }
  createQuickAccountSubGroup(status: boolean = true) {
    const dialogRef = this.dialogService.open(AccountSubGrouptypeLookupComponent, {
      header: 'Create Quick Account Sub Group',
      width: '60%',
      height: '52%'
    });

    dialogRef.onClose.subscribe((accountSubGroupId: number) => {
      if (accountSubGroupId) {
        this.getAccountSubGroupData(accountSubGroupId);
      }
    });
  }
  createQuickAccountType(status: boolean = true) {
    const dialogRef = this.dialogService.open(AccountTypeLookupComponent, {
      header: 'Create Quick Account Type ',
      width: '70%',
    });

    dialogRef.onClose.subscribe((accountTypeId: number) => {
      if (accountTypeId) {
        this.getAccountTypeData(accountTypeId);
      }
    });
  }

  getAccountTypeData(id: number) {
    this.accountService.getAccountTypeId(id).subscribe(
      (data: any) => {
        const AccountData = {
          value: data
        }
        this.setUOM(AccountData)
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while fetching AccountType data.' });
      }
    );
  }

  getAccountGroupData(id: number) {
    this.accountService.getAccountGroupTypeId(id).subscribe(
      (data: any) => {
        const AccountData = {
          value: data
        }
        this.setAccountGroup(AccountData)
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while fetching AccountGroup data.' });
      }
    );
  }
  getAccountSubGroupData(id: number) {
    this.accountService.getAccountSubGroupTypeId(id).subscribe(
      (data: any) => {
        const AccountData = {
          value: data
        }
        this.setAccountSubGroup(AccountData)
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while fetching AccountSubGroup data.' });
      }
    );
  }
  getAG() {
    this.accountService.getAllAccountGroups(this.pageRequest).subscribe({
      next: (data: any) => {
        this.AGDropdown = data.accountGroup;
      },
      error: error => {
        console.log(error);
      }
    });
  }
  getAccountSubGroupType() {
    this.accountService.getAllAccountSubGroups(this.pageRequest).subscribe({
      next: (data: any) => {
        this.AccountSubGroupDropdown = data.accountSubGroupType;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  setAccountGroup(event: any) {
    if (event && event.value) {
      const accountGroup = Array.isArray(event.value) ? event.value[0] : event.value;
      console.log('Account Group:', accountGroup);
      console.log('Form Controls:', this.createAccountForm.controls);

      if (this.createAccountForm.controls.accountGroupId && this.createAccountForm.controls.accountGroupCode) {
        this.createAccountForm.patchValue({
          accountGroupId: accountGroup.accountGroupId,
          accountGroupCode: accountGroup.accountGroupCode,
          accountGroupDescription: accountGroup.accountGroupDescription,
          accountGroupName: accountGroup.accountGroupName
        });
        console.log('Form Patched:', this.createAccountForm.value);
      } else {
        console.error('Form controls not found!');
      }
    } else {
      console.error('No event value received!');
    }
  }



  getUOM() {
    this.accountService.getAllAccountTypes(this.pageRequest).subscribe({
      next: (data: any) => {
        this.UOMDropdown = data.accountType;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  filterUOM(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.UOMDropdown as any[]).length; i++) {
      let uom = (this.UOMDropdown as any[])[i];
      if (uom.accountType.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(uom);
      }
    }
    this.filteruom = filtered;
  }
  filterAccountSubGroups(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    //console.log('Query:', query);  

    for (let i = 0; i < (this.AccountSubGroupDropdown as any[]).length; i++) {
      let uom = this.AccountSubGroupDropdown[i];
      if (uom.accountSubGroupCode.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(uom);
      }
    }

    this.filterAccountSubGroup = filtered;
  }

  setUOM(event: any) {
    if (event.value) {
      const selectedAccountType = event.value;

      if (this.accountTypeId === selectedAccountType.accountTypeId) {
        return;
      }

      this.createAccountForm.controls.accountTypeId.setValue(selectedAccountType.accountTypeId);
      this.accountTypeId = selectedAccountType.accountTypeId;
      this.createAccountForm.controls.accountType.setValue(selectedAccountType.accountType);
      this.createAccountForm.controls.accountTypeCode.setValue(selectedAccountType.accountTypeCode);
      this.createAccountForm.controls.financialStatement.setValue(selectedAccountType.accountTypeDescription);

      this.createAccountForm.controls.accountGroupName.reset();
      this.filterAG = [];

      this.filterAGs({ query: '' });
    }
  }


  filterAGs(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    if (!this.accountTypeId || this.accountTypeId === '') {
      this.filterAG = [];
      this.showErrorMessage('Please select an Account Type first');
      return;
    }

    for (let i = 0; i < this.AGDropdown.length; i++) {
      let group = this.AGDropdown[i];

      if (group.accountTypeId === this.accountTypeId) {
        if (group.accountGroupName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
          filtered.push(group);
        }
      }
    }

    this.filterAG = filtered;
  }


  showErrorMessage(message: string) {
    // You can display an error message using a toast or another method
    this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
  }


  getAccountCode(accountTypeCode: string) {
    this.loader = true;
    this.accountService.autogenerateAccountCode(accountTypeCode).subscribe({
      next: (data: any) => {
        this.createAccountForm.controls.accountCode.setValue(data);
        this.loader = false;
      },
      error: (error: any) => {
        console.log(error);
        this.loader = false;
      }
    });
  }


  setAccountSubGroup(event: any) {
    console.log('Event received:', event);

    if (event && event.value) {
      const accountSubGroup = Array.isArray(event.value) ? event.value[0] : event.value;

      console.log('Selected Account SubGroup:', accountSubGroup);
      console.log('Form Controls:', this.createAccountForm.controls);

      const formControls = this.createAccountForm.controls;

      if (formControls.accountSubGroupId && formControls.accountSubGroupCode && formControls.accountsubGroupDescription && formControls.accountSubGroupName) {
        this.createAccountForm.patchValue({
          accountSubGroupId: accountSubGroup.accountSubGroupId,
          accountSubGroupCode: accountSubGroup.accountSubGroupCode,
          accountsubGroupDescription: accountSubGroup.accountSubGroupDescription,
          accountSubGroupName: accountSubGroup.accountSubGroupName
        });

        this.accountSubGroupId = accountSubGroup.accountSubGroupId;

        console.log('Form After Patching:', this.createAccountForm.value);
      } else {
        console.error('Form controls missing or disabled!');
      }
    } else {
      console.error('No valid event value received!');
    }
  }



  get name(): String | null {
    return this.createAccountForm.controls.accountCode.value;
  }


  getit() {
    this.routers.queryParams.subscribe(params => {
      const id = Number(params['accountsId']);
      this.accountsId = id > 0 ? id : undefined;
      this.isEditMode = !!this.accountsId;

      if (this.isEditMode) {
        document.title = 'Update Account';

        // Fetch account details for edit mode
        this.accountService.getAccountsId(this.accountsId).subscribe(
          (data: any) => {
            if (data) {
              // Patch form with fetched data
              this.createAccountForm.patchValue(data);
              this.createAccountForm.patchValue({
                accountGroupId: data.accountGroupId,
                accountTypeId: data.accountTypeId,  // Ensure this is set in the form for editing
                accountGroupName: data.accountGroup?.accountGroupName,
                accountDescription: data.accountDescription,
                accountGroups: data.accountGroupCode,
                accountTypeCode: data.accountTypeCode,
                accountType: data.accountTypes?.accountType,
                accountSubGroup: data.accountSubGroupCode,
                accountSubGroupId: data.accountSubGroupId,
                accountSubGroupCode: data.accountSubGroupCode,
                accountSubGroupName: data.accountSubGroupType?.accountSubGroupName,
                accountTypeName: data.accountType?.accountType,
                financialStatement: data.financialStatement,
                ClosingBalance: data.closingBalance ?? data.ClosingBalance ?? 0
              });

              this.updateCurrentBalanceDisplay(data.closingBalance ?? data.ClosingBalance ?? 0);
              this.accountTypeId = data.accountTypeId;
              this.filterAGs({ query: '' });
              this.refreshAccountBalance(false);
              this.loadAccountLedger();
            } else {
              console.error('Account data not found.');
            }
          },
          (error: any) => {
            console.error('Error fetching account data:', error);
          }
        );
      } else {
        this.resetForm();
      }
    });
  }


  resetForm() {
    this.createAccountForm.reset();
    this.createAccountForm.controls.isActive.setValue(true);
  }

  get formControls() {
    return this.createAccountForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.createAccountForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }

  saveUnitOfMeasure(data: any, isEditMode: boolean) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }
    if (isEditMode) {
      this.updateAccount();
    } else {
      this.createAccount(data);
    }
  }

  updateAccount() {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    let updatedBy = localStorage.getItem('username');

    const accountSubGroupCode = Array.isArray(this.createAccountForm.controls.accountSubGroupCode.value)
      ? this.createAccountForm.controls.accountSubGroupCode.value[0]
      : this.createAccountForm.controls.accountSubGroupCode.value;

    const data = {
      accountsId: this.accountsId,
      accountCode: this.createAccountForm.controls.accountCode.value,
      accountName: this.createAccountForm.controls.accountName.value,
      accountDescription: this.createAccountForm.controls.accountDescription.value,
      accountTypeId: this.createAccountForm.controls.accountTypeId.value,
      accountTypeCode: this.createAccountForm.controls.accountTypeCode.value,
      accountSubGroupId: this.createAccountForm.controls.accountSubGroupId.value,
      accountSubGroupCode: accountSubGroupCode,
      accountGroupId: this.createAccountForm.controls.accountGroupId.value,
      accountGroupCode: this.createAccountForm.controls.accountGroupCode.value,
      tags: this.createAccountForm.controls.tags.value,
      isDepreciated: this.createAccountForm.controls.isDepreciated.value,
      createdBy: this.createAccountForm.controls.createdBy.value,
      accountGroups: this.createAccountForm.controls.accountGroups.value,
      accountType: this.createAccountForm.controls.accountType.value,
      accountSubGroup: this.createAccountForm.controls.accountSubGroup.value,
      financialStatement: this.createAccountForm.controls.financialStatement.value,
      isSalesTaxAcc: this.createAccountForm.controls.isSalesTaxAcc.value,
      isActive: this.createAccountForm.controls.isActive.value,
      ClosingBalance: this.createAccountForm.controls.ClosingBalance.value,
      UpdatedBy: updatedBy,
    };

    if (data) {
      this.accountService.updateAccount(data).subscribe({
        next: data => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Account Updated Successfully.' });
          setTimeout(() => {
            this.router.navigate(['/home/listAccounts']);
          }, 1000);
        },
        error: error => {
          console.error(error);
        }
      });
    } else {
      this.createAccount(data);
    }
  }


  createAccount(data: any) {
    this.createAccountForm.controls.createdBy.setValue(localStorage.getItem('username'));
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    const accountCode = String(this.createAccountForm.controls.accountCode.value).trim();

    if (!accountCode) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Account Code is required.' });
      return;
    }

    data.accountCode = accountCode;

    this.accountService.createAccount(data).subscribe({
      next: (response: any) => {
        if (response.success === true) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
          setTimeout(() => {
            this.router.navigate(['/home/listAccounts']);
          }, 1000);
        } else {
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: response.message });
        }
      },
      error: (error) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error while creating account.' });
      }
    });
  }



  Cancel() {
    this.router.navigate(['/home/listAccounts']);
  }
  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }
  checkAccountGroupCode() {
    if (!this.createAccountForm.controls.accountCode.value) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Please enter' });
      return;
    }
    if (!this.isEditMode) {
      this.accountService.checkAccountCode(this.createAccountForm.controls.accountCode.value).subscribe(
        (data: any) => {
          if (data.success == true) {
          } else {
            this.createAccountForm.controls.accountCode.setValue('');
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
            this.createAccountForm.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  formatClosingBalance(value: number | null | undefined): string {
    const num = Number(value ?? 0);
    return `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  refreshAccountBalance(showToast = true): void {
    const accountId = Number(this.accountsId);
    if (!accountId) {
      this.messageService.add({ severity: 'warn', summary: 'Balance', detail: 'Account not loaded.' });
      return;
    }

    this.balanceRefreshing = true;
    this.accountService.getAccountBalance(accountId).subscribe({
      next: (res: any) => {
        this.balanceRefreshing = false;
        this.applyRefreshedBalance(this.extractCurrentBalance(res), showToast);
      },
      error: () => {
        this.accountService.getAccountsId(accountId).subscribe({
          next: (data: any) => {
            this.balanceRefreshing = false;
            const current = Number(data?.closingBalance ?? data?.ClosingBalance ?? 0);
            this.applyRefreshedBalance(current, showToast);
          },
          error: () => {
            this.balanceRefreshing = false;
            this.messageService.add({ severity: 'error', summary: 'Balance', detail: 'Could not refresh account balance.' });
          }
        });
      }
    });
  }

  private extractCurrentBalance(res: any): number {
    const balance = res?.Balance ?? res?.balance;
    return Number(
      balance?.CurrentBalance ?? balance?.currentBalance ??
      res?.CurrentBalance ?? res?.currentBalance ?? 0
    );
  }

  private updateCurrentBalanceDisplay(value: number | null | undefined): void {
    const current = Number(value ?? 0);
    this.createAccountForm.patchValue({ ClosingBalance: current });
    this.displayCurrentBalance = this.formatClosingBalance(current);
  }

  private applyRefreshedBalance(current: number, showToast: boolean): void {
    this.updateCurrentBalanceDisplay(current);
    if (this.isEditMode && this.activeIndex === 1) {
      this.loadAccountLedger();
    }
    if (showToast) {
      this.messageService.add({ severity: 'success', summary: 'Balance', detail: 'Balance refreshed from posted GL.' });
    }
  }

  loadAccountLedger(): void {
    if (!this.accountsId) return;
    this.ledgerLoading = true;
    const from = this.ledgerFromDate ? this.formatDateForApi(this.ledgerFromDate) : undefined;
    const to = this.ledgerToDate ? this.formatDateForApi(this.ledgerToDate) : undefined;

    this.accountService.getAccountLedger(Number(this.accountsId), from, to).subscribe({
      next: (res: any) => {
        this.ledgerLoading = false;
        const ledger = res?.ledger ?? res?.Ledger;
        if (!ledger) return;

        this.ledgerOpeningBalance = Number(ledger.openingBalance ?? ledger.OpeningBalance ?? 0);
        this.ledgerClosingBalance = Number(ledger.closingBalance ?? ledger.ClosingBalance ?? 0);
        this.ledgerLines = (ledger.lines ?? ledger.Lines ?? []).map((row: any) => ({
          transactionDate: row.transactionDate ?? row.TransactionDate,
          transactionNo: row.transactionNo ?? row.TransactionNo ?? '',
          transactionType: row.transactionType ?? row.TransactionType ?? '',
          debitAmount: Number(row.debitAmount ?? row.DebitAmount ?? 0),
          creditAmount: Number(row.creditAmount ?? row.CreditAmount ?? 0),
          runningBalance: Number(row.runningBalance ?? row.RunningBalance ?? 0),
        }));
      },
      error: () => {
        this.ledgerLoading = false;
        this.ledgerLines = [];
        this.messageService.add({ severity: 'error', summary: 'Ledger', detail: 'Failed to load account ledger.' });
      }
    });
  }

  clearLedgerFilters(): void {
    this.ledgerFromDate = null;
    this.ledgerToDate = null;
    this.loadAccountLedger();
  }

  private formatDateForApi(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

}






